import React from "react";
import PropTypes from "prop-types";

const CoreReportTitleBar = ({
  reportName,
  reportSubtitle,
  isActive,
  onClick
}) => {
  return (
    <h2
      style={{
        fontWeight: "bold",
        textAlign: "left",
        //borderBottom: `2px solid ${isActive ? "#13a89e" : "#dedede"}`,
        padding: "8px 16px",
        //color: "#fff",
        cursor: "pointer",
        backgroundColor: "#fff",
        borderBottom: "2px solid #eee",
        color: isActive ? "#13a89e" : "#143660",
        margin: 0
      }}
      onClick={onClick}
    >
      {/*<IconLight*/}
      {/*icon={"check-circle"}*/}
      {/*title={"Select report"}*/}
      {/*style={{ color: isActive ? "#13a89e" : "inherit" }}*/}
      {/*/>{" "}*/}
      {reportName}{" "}
      <small style={{ fontWeight: "normal" }}>{reportSubtitle}</small>
    </h2>
  );
};

CoreReportTitleBar.propTypes = {
  reportName: PropTypes.string.isRequired,
  reportSubtitle: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default CoreReportTitleBar;



// WEBPACK FOOTER //
// ./src/views/core/core_report_title_bar/CoreReportTitleBar.jsx